<template>
  <div class="footer-block">
    <slot></slot>
  </div>
</template>

<style scoped>
.footer-block {
  text-align: center;
  background-color: #7bbfd1;
  color: #fff;
}
.footer-block button {
  width: 180px;
  margin-top:12px;
  margin-bottom:12px;
}
</style>

<script>
/* eslint-disable semi */
import { Component } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

@Component
export default class AppFooterBlock extends AppComponent {}
</script>



// WEBPACK FOOTER //
// src/app/parts/AppFooterBlock.vue